const SldsPill = () => {
    return (
        <span class="slds-pill slds-pill_link">
            <span class="slds-pill__icon_container">
                <span class="slds-avatar slds-avatar_circle" title="User avatar">
                    <img alt="Person name" src="/images/avatar2.jpg" title="User avatar" />
                </span>
            </span>
            <a href="#" class="slds-pill__action" title="Full pill label verbiage mirrored here">
                <span class="slds-pill__label">Pill Label</span>
            </a>
            <button class="slds-button slds-button_icon slds-button_icon slds-pill__remove" title="Remove">
                <svg class="slds-button__icon" aria-hidden="true">
                    <use xlinkHref="/icons/utility-sprite/svg/symbols.svg#close"></use>
                </svg>
                <span class="slds-assistive-text">Remove</span>
            </button>
        </span>
    )
}


export default SldsPill;